import axios from 'axios';

const defaultApiBaseUrl = 'https://apiagriinventory.barbazampc.cloud/api';
const configuredApiBaseUrl = process.env.REACT_APP_API_URL || defaultApiBaseUrl;
const apiBaseUrl = configuredApiBaseUrl.includes('agriapi.barbazampc.coop')
  ? defaultApiBaseUrl
  : configuredApiBaseUrl;
//const apiBaseUrl = 'http://localhost:8000/api';

const client = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default client;


